import React from "react";
import InfoBlock from "../grundelemente/InfoBlock";
import PropTypes from "prop-types";

import moment from "moment-timezone";

/* auf chrome und IE macht die TZ aerger. deaktiviert/entfernt bis mir was besseres einfaellt! */

const InfoDate = props => (
	<InfoBlock>
		<span>
			{moment(props.date).tz(props.tz).format("kk:mm:ss")}
		</span>
	</InfoBlock>
);

InfoDate.propTypes = {
	date: PropTypes.string.isRequired,
	tz: PropTypes.string.isRequired
};

export default InfoDate;
